import {Component} from '@angular/core';
@Component({
    selector: 'layout-block-recommendations',
    standalone: false,
    templateUrl: './sub-block-recommendations.component.html'
})
export class SubBlockRecommendationsComponent {

}
